import { render, staticRenderFns } from "./section4.vue?vue&type=template&id=61e43822&scoped=true&"
import script from "./section4.vue?vue&type=script&lang=js&"
export * from "./section4.vue?vue&type=script&lang=js&"
import style0 from "./section4.vue?vue&type=style&index=0&id=61e43822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e43822",
  null
  
)

export default component.exports